export type FinanceCostCategory = 'marketing' | 'operating' | 'per_order';
export type FinanceCostFrequency = 'monthly' | 'per_order';

const MARKETING_LABEL_RE =
  /\b(tiktok|ads|adv|advert|marketing|influencer|meta|facebook|google|pinterest|snapchat|youtube|affiliate|media\s*buy|sponsor|creator|ugc|untracked\s*ads|paid\s*social)\b/i;

const OPERATING_LABEL_RE =
  /\b(aziend|operating|company|structure|uffic|office|stipend|salary|rent|affitto|overhead|team|hr|legal|accountant|fisso|fixed\s*cost|costo\s*aziendale)\b/i;

const PER_ORDER_LABEL_RE =
  /\b(per\s*order|\/\s*order|\/\s*ordine|fulfillment|packaging|pick\s*&?\s*pack|logistics|shipping\s*fee|transaction)\b/i;

export function inferCostCategory(
  label: string,
  frequency: FinanceCostFrequency = 'monthly',
): FinanceCostCategory {
  const text = label.trim();
  if (!text) return frequency === 'per_order' ? 'per_order' : 'operating';
  if (PER_ORDER_LABEL_RE.test(text) || (frequency === 'per_order' && !MARKETING_LABEL_RE.test(text))) {
    return 'per_order';
  }
  if (MARKETING_LABEL_RE.test(text)) return 'marketing';
  if (OPERATING_LABEL_RE.test(text)) return 'operating';
  return frequency === 'per_order' ? 'per_order' : 'operating';
}

export function categoryDisplayLabel(category: FinanceCostCategory): string {
  if (category === 'marketing') return 'Marketing';
  if (category === 'per_order') return 'Per order';
  return 'Operating';
}

export function categoryImpactHint(category: FinanceCostCategory): string {
  if (category === 'marketing') {
    return 'Adds to marketing spend · recalculates CM2, ROAS, ACOS';
  }
  if (category === 'per_order') {
    return 'Deducts per order · creates a new CM row';
  }
  return 'Deducts from CM2+ · creates CM3, CM4…';
}

export const COST_QUICK_SUGGESTIONS = [
  'TikTok',
  'Influencer marketing',
  'Company costs',
  'Office rent',
  'Per-order packaging',
] as const;
